import React, { PureComponent, Fragment, memo } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { Notificacion } from '../../../../../Util/Notificacion/Notificacion';
import { Obtener_Ordenes_Request, Obtener_Tiempos_Ordenes_Request } from '../../../../../../request/CallCenterMonitorRequest';
import { Obtener_Sucursales_Monitoreo_Request } from '../../../../../../request/SucursalRequest';
import GridOrdenes from '../../GridOrdenes/GridOrdenes';
import TabPanelFiltro from './TabPanelFiltro/TabPanelFiltro';
import Constantes from '../../../../../Util/Constantes';

class TabPanelBody extends PureComponent {
    _isMounted = false;
    state = {
        sucursalSeleccionada: 0,
        estatusSeleccionado: '',
        estadoExpressSeleccionado: '',
        fecha_activa: [new Date(), new Date()],
        estadoOrdenes: 0,
        txtBuscar: '',
        ordenes: [],
        estatus: [],
        sucursales: []
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.props.activo) {
            this.initData();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.activo && (this.props.activo !== prevProps.activo || (this.props.debeRefrescar && this.props.debeRefrescar !== prevProps.debeRefrescar))) {
            this.initData();
        }
    }

    initData = () => {
        this.setState({ estadoOrdenes: this.props.estadoOrdenes }, () => {
            this.obtenerSucursales();
            if (this.props.estadoOrdenes !== '3') {
                this.obtenerOrdenes();
                this.obtenerEstatus();
            }
        });
    }

    obtenerSucursales = async () => {
        if (this.props.token) {
            const { fecha_activa, estadoOrdenes, estadoExpressSeleccionado } = this.state;
            const [fechaIni, fechaFin] = fecha_activa;

            const response = await Obtener_Sucursales_Monitoreo_Request(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, estadoOrdenes, fechaIni, fechaFin, estadoExpressSeleccionado);
            if (response.Exitoso) {
                this._isMounted && this.setState({ sucursalSeleccionada: 0, sucursales: response.Datos });
            }
            else {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    obtenerOrdenes = async () => {
        if (this.props.token) {
            const { sucursalSeleccionada, estadoOrdenes, estadoExpressSeleccionado } = this.state;
            const [fechaIni, fechaFin] = this.state.fecha_activa;
     
            const fecha_ini = moment.utc().year(fechaIni.getFullYear()).month(fechaIni.getMonth()).date(fechaIni.getDate()).startOf('day').toISOString();
            const fecha_fin = moment.utc().year(fechaFin.getFullYear()).month(fechaFin.getMonth()).date(fechaFin.getDate()).endOf('day').toISOString();
            
            const response = await Obtener_Ordenes_Request(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, sucursalSeleccionada, estadoOrdenes, fecha_ini, fecha_fin, estadoExpressSeleccionado);
            if (response.Exitoso) {
                this._isMounted && this.setState({ ordenes: response.Datos });
            }
            else {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    obtenerEstatus = async () => {
        if (this.props.token) {
            const { sucursalSeleccionada, estadoOrdenes, estadoExpressSeleccionado } = this.state;
            const response = await Obtener_Tiempos_Ordenes_Request(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, sucursalSeleccionada, estadoOrdenes, estadoExpressSeleccionado);
            if (response.Exitoso) {
                this._isMounted && this.setState({ estatus: response.Datos });
            }
            else {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    onChangeSucursalHandler = event => {
        const { value } = event.target;
        this.setState({ sucursalSeleccionada: value }, () => {
            this.obtenerOrdenes();
            this.obtenerEstatus();
        });
    }

    onChangeEstatusHandler = event => {
        const { value } = event.target;
        this.setState({ estatusSeleccionado: value });
    }

    onChangeEstadoExpressHandler = event => {

        const { value } = event.target;
        if (value) {
            this.setState({ estadoExpressSeleccionado: value }, () => {
                this.obtenerOrdenes();
                this.obtenerEstatus();
                this.obtenerSucursales();
            });
        }
    }

    onChangeFechaActiva = dates => {
        this.setState({ fecha_activa: dates }, () => {
            this.obtenerOrdenes();
            if (moment.utc(dates[0]).isSame(moment(), 'day')) {
                this.obtenerEstatus();
            }
            if (this.state.estadoOrdenes === '2' || this.state.estadoOrdenes === '3') {
                this.obtenerSucursales();
            }
        });
    }

    onChangeBuscar = event => {
        const { value } = event.target;
        this.setState({ txtBuscar: value });
    }

    render() {
        const { ordenes, estatus, txtBuscar, sucursales, estadoOrdenes, estatusSeleccionado, estadoExpressSeleccionado } = this.state;

        let ordenesFiltradas = ordenes;
        if (txtBuscar) {
            ordenesFiltradas = ordenes.filter(orden => Object.keys(orden).some(propiedad => orden[propiedad].toString().toLowerCase().includes(txtBuscar.toLowerCase())));
        }

        const estadoActivo = estadoExpressSeleccionado !== Constantes.c_Estatus_Anulacion && estadoExpressSeleccionado !== Constantes.c_Estatus_Borrada && estadoExpressSeleccionado !== Constantes.c_Estatus_Terminada;
        
        return (
            <Fragment>
                {this.props.children}
                <div className="row">
                    <div className="col-md-12">
                        <div className="lista-ordenes">
                            <TabPanelFiltro
                                activo={this.props.activo}
                                sucursales={sucursales}
                                mostrarEstatus={this.props.mostrarFiltroEstatus}
                                mostrarEstadosExpress={this.props.mostrarEstadosExpress}
                                mostrarCalendario={this.props.mostrarCalendario}
                                permitirFechasAnteriores={estadoOrdenes === '2' || estadoOrdenes === '3'}
                                permitirFechasPosteriores={estadoOrdenes !== '2'}
                                mostrarBuscar={true}
                                textoBuscar={txtBuscar}
                                onChangeSucursal={this.onChangeSucursalHandler}
                                onChangeEstatus={this.onChangeEstatusHandler}
                                onChangeEstadoExpress={this.onChangeEstadoExpressHandler}
                                onChangeFechaActiva={this.onChangeFechaActiva}
                                onChangeBuscar={this.onChangeBuscar} />
                            <GridOrdenes
                                tipo={this.props.tipoGrid}
                                linkDetalle={this.props.linkDetalle}
                                ordenes={ordenesFiltradas}
                                estatus={estatus}
                                tiempoActivo={estadoOrdenes !== '2' && estadoActivo}
                                estatusFiltro={estatusSeleccionado}
                                estadoOrdenes={estadoOrdenes} />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
};

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        callCenter: state.parametros.callCenter
    };
};

export default connect(mapStateToProps)(memo(TabPanelBody));